import type { ProductId, ProductVersionId, AttributeId } from './ids';

export type AttributeType =
  | 'single_select'
  | 'multi_select'
  | 'number'
  | 'text'
  | 'boolean'
  | 'color'
  | 'image'
  | 'component_ref';

export interface AttributeValue {
  id: string;
  key: string;
  label: string;
  code?: string;
  color?: string;
  thumbnailUrl?: string;
  /**
   * When `false`, the value is hidden in the player and excluded from “allowed option” lists.
   * Omitted or `true` = active (backward compatible).
   */
  enabled?: boolean;
  metadata?: Record<string, unknown>;
}

export interface ProductAttribute {
  id: AttributeId;
  key: string;
  label: string;
  type: AttributeType;
  required?: boolean;
  defaultValue?: string | number | boolean | string[];
  values?: AttributeValue[];
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  /** Text attributes: max input length (graphemes). */
  maxLength?: number;
  minLength?: number;
  groupKey?: string;
  sortOrder?: number;
  metadata?: Record<string, unknown>;
}

export interface ProductComponent {
  id: string;
  key: string;
  label: string;
  type: 'replaceable_component' | 'optional_component' | 'child_collection';
  required?: boolean;
  allowedVariantIds?: string[];
  sortOrder?: number;
  metadata?: Record<string, unknown>;
}

export interface ProductModel {
  productId: ProductId;
  productVersionId: ProductVersionId;
  modelId: string;
  modelVersionId: string;
  id: string;
  name: string;
  description?: string;
  attributes: ProductAttribute[];
  components: ProductComponent[];
  metadata?: Record<string, unknown>;
}
